import { render, staticRenderFns } from "./BaseTableComponent.vue?vue&type=template&id=f680d49e&"
import script from "./BaseTableComponent.vue?vue&type=script&lang=ts&"
export * from "./BaseTableComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f680d49e')) {
      api.createRecord('f680d49e', component.options)
    } else {
      api.reload('f680d49e', component.options)
    }
    module.hot.accept("./BaseTableComponent.vue?vue&type=template&id=f680d49e&", function () {
      api.rerender('f680d49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/BaseTableComponent.vue"
export default component.exports